import { InjectionLineStatusBase } from './base/injection-line-status-base';

export class InjectionLineStatus extends InjectionLineStatusBase { }